import React from "react";
import SEO from "./SEO";
import BackLink from "./BackLink";
import { company } from "../data/company";
import "./Datenschutz.css";

const Datenschutz = () => {
  return (
    <div className="datenschutz-container">
      <SEO
        title="Datenschutz | M.F.D. Dienstleistungs GmbH & Co. KG"
        description="Datenschutzerklärung der M.F.D. Dienstleistungs GmbH & Co. KG in Berlin: Kontakt, Karte, Speicherdauer und Ihre Rechte."
        keywords="Datenschutz, Datenschutzerklärung, M.F.D. Gebäudereinigung, Berlin"
        url="https://www.mfd-berlin.com/datenschutz"
      />

      <BackLink />
      <h1>Datenschutzerklärung</h1>
      <p className="datenschutz-stand">Stand: 30. September 2026</p>

      <h2>1. Verantwortliche Stelle</h2>
      <p>
        {company.legalName}
        <br />
        {company.street}
        <br />
        {company.postalCode} {company.city}
        <br />
        Telefon:{" "}
        <a href={`tel:${company.phones[0].tel}`}>{company.phones[0].display}</a>
        <br />
        E-Mail: <a href={`mailto:${company.email}`}>{company.email}</a>
      </p>
      <p>
        Verantwortlich ist das Unternehmen selbst. Eine Datenschutzbeauftragte
        oder ein Datenschutzbeauftragter ist nicht benannt.
      </p>

      <h2>2. Welche Daten wir verarbeiten</h2>
      <p>
        Beim Aufruf dieser Website verarbeitet der Hosting-Anbieter technisch
        erforderliche Verbindungsdaten, insbesondere IP-Adresse, Datum und
        Uhrzeit, Browsertyp und Betriebssystem. Rechtsgrundlage ist unser
        berechtigtes Interesse an einem sicheren und stabilen Betrieb (Art. 6
        Abs. 1 lit. f DSGVO).
      </p>
      <p>
        Wenn Sie uns per E-Mail oder über das Angebotsformular schreiben,
        verarbeiten wir die Angaben, die Sie uns schicken: Name, Telefonnummer,
        E-Mail-Adresse, Ort, gewünschte Leistung und Ihre Nachricht.
        Das Formular öffnet Ihr E-Mail-Programm und richtet die Nachricht an{" "}
        {company.inquiryEmail}. Es wird dabei kein externer Formulardienst
        eingeschaltet. Rechtsgrundlage ist die Bearbeitung Ihrer Anfrage vor
        einem Vertrag (Art. 6 Abs. 1 lit. b DSGVO). Die Daten bleiben
        gespeichert, solange die Anfrage läuft und gesetzliche
        Aufbewahrungsfristen es verlangen, und werden danach gelöscht. Wir
        geben diese Daten nicht zu Werbezwecken weiter.
      </p>

      <h2>3. Karte</h2>
      <p>
        Die Karte im Kontaktbereich wird erst geladen, wenn Sie sie ausdrücklich
        öffnen. Dann baut Ihr Browser eine Verbindung zu Google Ireland Limited
        bzw. Google LLC auf. Google kann dabei die IP-Adresse und weitere
        technische Daten verarbeiten. Rechtsgrundlage ist Ihre Einwilligung
        durch das Öffnen der Karte (Art. 6 Abs. 1 lit. a DSGVO). Hinweise von
        Google finden Sie unter{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          policies.google.com/privacy
        </a>
        .
      </p>

      <h2>4. Lokale Speicherung</h2>
      <p>
        Wir setzen keine Analyse- und keine Marketing-Cookies ein. Ihre
        Entscheidung im Hinweis am unteren Rand wird nur lokal in Ihrem Browser
        gespeichert, damit der Hinweis nicht bei jedem Besuch erneut erscheint.
        Es findet keine Auswertung des Nutzungsverhaltens statt.
      </p>

      <h2>5. Ihre Rechte</h2>
      <p>Sie haben gegenüber uns das Recht auf:</p>
      <ul>
        <li>Auskunft über die gespeicherten Daten (Art. 15 DSGVO)</li>
        <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen eine Verarbeitung nach Art. 6 Abs. 1 lit. f DSGVO (Art. 21 DSGVO)</li>
      </ul>
      <p>
        Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die
        Zukunft widerrufen. Außerdem können Sie sich bei einer
        Aufsichtsbehörde beschweren. Zuständig ist die Berliner Beauftragte für
        Datenschutz und Informationsfreiheit, Friedrichstr. 219, 10969 Berlin,{" "}
        <a
          href="https://www.datenschutz-berlin.de"
          target="_blank"
          rel="noopener noreferrer"
        >
          datenschutz-berlin.de
        </a>
        .
      </p>

      <h2>6. Pflicht zur Bereitstellung</h2>
      <p>
        Sie müssen uns keine Daten schicken. Ohne Name und eine
        Kontaktmöglichkeit können wir eine Angebotsanfrage aber nicht beantworten.
      </p>
    </div>
  );
};

export default Datenschutz;
